import { render, staticRenderFns } from "./ResearchAnnotationsPlot.vue?vue&type=template&id=485fd85c"
import script from "./ResearchAnnotationsPlot.vue?vue&type=script&lang=js"
export * from "./ResearchAnnotationsPlot.vue?vue&type=script&lang=js"
import style0 from "./ResearchAnnotationsPlot.vue?vue&type=style&index=0&id=485fd85c&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('485fd85c')) {
      api.createRecord('485fd85c', component.options)
    } else {
      api.reload('485fd85c', component.options)
    }
    module.hot.accept("./ResearchAnnotationsPlot.vue?vue&type=template&id=485fd85c", function () {
      api.rerender('485fd85c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchAnnotationsPlot.vue"
export default component.exports